import classNames from 'classnames';
import ContentBlock from '../ContentBlock';
import FlexContainer from '../FlexContainer';
import Txt from '../Txt';
import View from '../View';
import styles from './ToDoHeading.module.scss';

/**
 * ToDoHeading
 *
 * @return {JSX.Element}
 */
const ToDoHeading = ({
  className,
  title,
  description1,
  description2,
  completed,
  completedOf,
  noDivider,
  noLabel,
  caption,
  title2,
  ...rest
}) => {
  return (
    <ContentBlock
      className={classNames(
        styles.ToDoHeading,
        noDivider && styles.ToDoHeading__noDivider,
        className,
        ToDoHeading.displayName
      )}
      gap
      column
      {...rest}
    >
      {title ? (
        <View className={styles.Header}>
          <Txt xxx>{title}</Txt>
        </View>
      ) : null}
      <FlexContainer gap alignCenter>
        <FlexContainer flex gapHalf column>
          {title2 ? <Txt xx>{title2}</Txt> : null}
          {description1 ? <Txt caption={caption}>{description1}</Txt> : null}
          {description2 ? <Txt regular>{description2}</Txt> : null}
        </FlexContainer>
        {completedOf ? (
          <FlexContainer column alignCenter justifyContentCenter>
            <View className={styles.CompletedBlock}>
              <Txt xxxx>{completed || 0}</Txt>
              <Txt>/ {completedOf}</Txt>
            </View>
            {noLabel ? null : <Txt caption>DONE</Txt>}
          </FlexContainer>
        ) : null}
      </FlexContainer>
    </ContentBlock>
  );
};

ToDoHeading.displayName = 'ToDoHeading';

export default ToDoHeading;
